<script>
import { getSessionNames } from '../table-headers'
import { collectorPublicationsMapper as StoreMapper } from '../store'
import ViewCollectorPublicationsView from '@/views/CollectorPublications/PublicationsView.vue'
import {
  createPermissionsGroupsCopyAteModal,
  createImportKimsModal,
} from '../utils'

import BasePublicationsForm from '@/components/admin/collector/publications/BasePublicationsForm.vue'

export default {
  name: 'PublicationsForm',
  components: {
    ViewCollectorPublicationsView,
  },
  extends: BasePublicationsForm,
  computed: {
    ...StoreMapper.mapState(['sessions', 'subjects']),
    sessionNames() {
      return getSessionNames(this.data, this.sessions)
    },
    editRoute() {
      return {
        props: { id: 0 },
      }
    },
    generateKims() {
      return this.data.variants_count && this.data.participants_count
    },
    importKims() {
      return (
        this.data.target_complects_count
        && this.data.target_complects_count === this.data.generated_complects_count
      )
    },
    importCriteria() {
      return this.hasCriteriaStorage && this.importKims
    },
  },
  methods: {
    async onImportCriteria() {
      const propsData = {
        storage_id: this.data.lk_storage_id,
        criteria_storage_id: this.data.lk_criteria_storage_id,
        collector_publication_id: this.data.publication_id,
        session_digit_code: this.data.session_digit_code,
        subject_digit_code: this.data.subject_digit_code,
        is_criteria: true,
      }
      const modal = await createImportKimsModal(this, propsData)
      await modal.open()
      await this.getImportKimsTasks(this.data.lk_criteria_storage_id, true)
    },
    async onImportKims() {
      const propsData = {
        storage_id: this.data.lk_storage_id,
        collector_publication_id: this.data.publication_id,
        session_digit_code: this.data.session_digit_code,
        subject_digit_code: this.data.subject_digit_code,
      }
      const modal = await createImportKimsModal(this, propsData)
      await modal.open()
      await this.getImportKimsTasks(this.data.lk_storage_id)
    },
    async onUploadFile(file, type) {
      const propsData = {
        file,
        publicationId: this.data.publication_id,
        type,
      }
      const modal = await createPermissionsGroupsCopyAteModal(this, propsData)
      const result = await modal.open()
      if (!result) return

      await this.updatePublication()

      this.form = {
        ...this.form,
        ...result,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.PublicationForm {
  &__link {
    display: block;
    margin: 0 4px;
    color: $webflow-color-black;
    cursor: pointer;
    text-decoration-line: none;

    &:hover {
      opacity: 0.75;
    }
  }

  &__link-icon {
    pointer-events: none;
  }

  .LKMunMehCardProgress {
    margin-top: 16px;

    &__text {
      margin-bottom: 16px;
      font-size: 14px;
      font-weight: bold;
      color: $webflow-color-blue-dark-2;
    }

    &__progress {
      border-radius: 4px;
    }

    .v-progress-linear {
      &__buffer {
        background-color: $webflow-color-grey;
      }

      .primary {
        background-color: $webflow-color-green;
      }
    }
  }
}
</style>
